let url = document.location.href;
let isMeuVivo = url.indexOf("cliente-especial-meuvivo") > -1;
// let isPortabilidade = url.search(/movimento=portabilidade/gi) > -1;

export default function getCurrentLp() {
  let lp = "captive";
  if (isMeuVivo) lp = "meuVivo";
  // if (isPortabilidade) lp = "portabilidade";

  return lp;
}
